<!-- Set adaptive position to false, so that ngx popover won't check overflow within the data table -->
<lib-popover
    *ngIf="params.value && overflow"
    [popoverLabel]="params.value"
    popoverPlacement="auto"
    popoverTriggerEvents="mouseenter:mouseleave"
    [adaptivePosition]="false"
    dataTableTooltipStyle="true"
    dataTableTooltipNoSpacing="true">
    {{ params.value }}
</lib-popover>
<span class="data-table__content" [hidden]="overflow">{{ params.value }}</span>
